import { render, staticRenderFns } from "./SendConfirmation.vue?vue&type=template&id=0414a73a"
import script from "./SendConfirmation.vue?vue&type=script&lang=ts"
export * from "./SendConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports